import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {Table, Button} from  'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import ModalDetails from './modalDetails';
import Help from '../../generics/help';
import moment from 'moment';

const Config = require('../../../config');

class WarehouseProduct extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.getList = this.getList.bind(this);
		this.showAll = this.showAll.bind(this);

		this.state = {
			products:[],
			totals: [],
			filter:""
		}
	}

	componentDidMount(){
		this.getList();
		
	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'plasmatic_product/stock/'+sessionStorage.getItem('health_facilities_id'),{
			method:'get',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var products = [];
				var totals = [];

				response.map((res)=>{
					var count = 0
					res.stock.map((s)=>{

						var aux = {
							name: res.product.name,
							code: res.product.code,
							barcode: res.product.barcode,
							presentation: res.product.presentation,
							lote: s.lot_number,
							caducidad: s.expiration_date !== null ? moment(s.expiration_date).format('DD/MM/YYYY') : '',
							amount: s.total,
							entry_date: s.entry_date !== null ? moment(s.entry_date).format('DD/MM/YYYY') : '',
						}

						count += s.total;

						products.push(aux);
					
						
					})

					if(this.state.all){
						totals.push({
							product: res.product.name,
							amount: count
						});	
					}else{
						if(count > 0){
							totals.push({
								product: res.product.name,
								amount: count
							});
						}
					}
					

				})

				this.setState({products:products, totals: totals});
			}
		});
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	filter(row){
		var res = true;

		if(row !== null){
			var string = row.product+' '+row.name+' '+row.code+' '+row.barcode+' '+row.presentation+' '+row.lote;

			if(string.indexOf(this.state.filter.toUpperCase()) !== -1){
				res = true;
			}else{
				res = false;
			}
		}
		
		/*if(row !== null){
			if(
				row.name !== null &&
				row.code !== null &&
				row.barcode !== null &&
				row.presentation !== null
			){
				if(
					row.name.indexOf(this.state.filter.toUpperCase()) !== -1 ||
					row.code.indexOf(this.state.filter.toUpperCase()) !== -1 ||
					row.barcode.indexOf(this.state.filter.toUpperCase()) !== -1 ||
					row.presentation.indexOf(this.state.filter.toUpperCase()) !== -1 
				){
					res = true;
				}else{
					res = false;
				}
			}

		}*/

		return res;
	}

	viewInformation(id, name){
		this.modal_details.handleShow(id, name);
	}

	showAll(e){
		this.setState({all: !this.state.all});

		setTimeout(()=>{
			this.getList();
		}, 500)
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Productos Hemostáticos ->
						Almacén
					</h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_plasmatic_prod"} 
	                submenu={"help_plasmatic_storage"}  />

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<input type="text" className="form-control" name="filter" id="filter" placeholder={"Filtro..."}
							value={this.state.filter} onChange={this.handleChange} />
						
					</div>

				</div>

				<div className="col-xs-12">
					<fieldset>
						<legend>Productos</legend>
						<div>
							<Table style={{margin:0}}>
								<thead>
									<tr>
										<th style={{width:'45%'}}>Nombre</th>
										<th style={{width:'10%'}}>Codigo</th>
										{/*<th>Codigo de Barras</th>*/}
										<th style={{width:'10%'}}>Presentación</th>
										<th style={{width:'10%'}}>Lote</th>
										<th style={{width:'15%'}}>F. Entrada</th>
										<th style={{width:'15%'}}>Caducidad</th>
										<th style={{width:'10%'}}>Cantidad</th>
									</tr>
								</thead>
							</Table>
						</div>
						<div style={{overflow:'scroll', height:'200px'}} className="form-group">
							<Table responsive hover>
								<tbody>
									{this.state.products.map((p, i)=>{
										return  this.filter(p) ?
											<tr key={i} >
												<td style={{width:'45%'}}>{p.name}</td>
												<td style={{width:'10%'}}>{p.code}</td>
												{/*<td>{p.barcode}</td>*/}
												<td style={{width:'10%'}}>{p.presentation}</td>
												<td style={{width:'10%'}}>{p.lote}</td>
												<td style={{width:'15%'}}>{p.entry_date}</td>
												<td style={{width:'15%'}}>{p.caducidad}</td>
												<td style={{width:'10%'}}>{p.amount}</td>
											</tr>
										: null
									})}
								</tbody>
							</Table>
						</div>
					</fieldset>
				</div>

				<div className="col-xs-12 col-sm-6 form-group">
					<fieldset>
						<legend>Totales</legend>
						<div className="col-xs-12">
							<input type="checkbox" id="all" name="all" value={this.state.all} checked={this.state.all}
								onChange={(e)=>this.showAll(e)} /> Ver Todos
						</div>
						<div>
							<Table style={{margin:0}}>
								<thead>
									<tr>
										<th style={{width:'90%'}}>Nombre</th>
										<th style={{width:'10%'}}>Total</th>
									</tr>
								</thead>
							</Table>
						</div>
						<div style={{overflow:'scroll', height:'200px'}}>
							<Table responsive hover>
								<tbody>
									{this.state.totals.map((p, i)=>(
										this.filter(p) ?
											<tr key={i} >
												<td style={{width:'90%'}}>{p.product}</td>
												<td style={{width:'10%'}}>{p.amount}</td>
											</tr>
										:null
									))}
								</tbody>
							</Table>
						</div>
					</fieldset>
				</div>



				<ModalDetails {...this.props} onRef={ref => (this.modal_details = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(WarehouseProduct);